import script from "./index-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./index-page.vue?vue&type=script&setup=true&lang=ts"

import "./index-page.vue?vue&type=style&index=0&id=51cd2852&lang=css"
import "./index-page.vue?vue&type=style&index=1&id=51cd2852&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51cd2852"]])

export default __exports__